import { computeAllowedFromDeductions, hasPayorDeductions } from '../../../lib'
import type { PatientClaimFormApi } from '../../../model'
import { CurrencyCell } from './currency-cell'

const tdClass =
  'border-divider border-b border-r p-2 focus-within:shadow-[inset_0_0_0_1px_var(--color-primary-main)]'

/**
 * Allowed Amount cell with conditional editability.
 * Editable when no payor deductions entered; auto-calculated and disabled otherwise.
 */
export function AllowedAmountCell({
  form,
  index,
  recordServiceLines,
}: {
  form: PatientClaimFormApi
  index: number
  recordServiceLines: () => void
}) {
  return (
    <form.Subscribe
      selector={(state) => {
        const sl = state.values.serviceLines[index]
        return {
          billedAmount: sl?.billedAmount ?? null,
          hasDeductions: sl ? hasPayorDeductions(sl) : false,
          adjustments: sl?.adjustments?.amount ?? null,
          otherPlan: sl?.otherPlan ?? null,
        }
      }}
    >
      {({ billedAmount, hasDeductions, adjustments, otherPlan }) => {
        const isDisabled = billedAmount == null || hasDeductions
        const autoValue = hasDeductions
          ? computeAllowedFromDeductions(billedAmount, adjustments, otherPlan)
          : undefined

        return (
          <td className={tdClass}>
            <form.Field name={`serviceLines[${index}].allowedAmount`}>
              {(field) => {
                // When auto-calculated, sync form value
                if (autoValue !== undefined && field.state.value !== autoValue) {
                  // Use setTimeout to avoid updating during render
                  setTimeout(() => field.handleChange(autoValue), 0)
                }

                return (
                  <CurrencyCell
                    value={autoValue ?? field.state.value}
                    disabled={isDisabled}
                    onCentsChange={(cents) => field.handleChange(cents)}
                    onBlur={recordServiceLines}
                  />
                )
              }}
            </form.Field>
          </td>
        )
      }}
    </form.Subscribe>
  )
}
